import { useEffect } from 'react';

import { useMenuPositionProps } from './useMenuPosition.types';

const useMenuPosition = ({ isDropdownOpen, listRef, dropdownRef }: useMenuPositionProps): void => {
  const calculateDropdownPosition = (): void => {
    if (!isDropdownOpen || !listRef?.current) {
      return;
    }

    const dropdownListRect = listRef?.current?.getBoundingClientRect();
    const dropdownRect = dropdownRef?.current?.getBoundingClientRect();

    if (dropdownRect === undefined || dropdownListRect === undefined) {
      return;
    }

    const availableWidth: number = document.body.clientWidth;
    const exceedingWidth: boolean = dropdownRect.left + dropdownListRect.width > availableWidth;
    if (exceedingWidth) {
      listRef.current.style.right = '0';
      listRef.current.style.left = 'auto';
    } else {
      listRef.current.style.right = 'auto';
      listRef.current.style.left = '0';
    }

    const availableHeight: number = document.body.clientHeight;
    const exceedingHeight: boolean = dropdownRect.bottom + dropdownListRect.height > availableHeight;
    const anchorHeight = dropdownRect.height;
    if (exceedingHeight) {
      listRef.current.style.bottom = `${anchorHeight}px`;
      listRef.current.style.top = 'auto';
    } else {
      listRef.current.style.bottom = 'auto';
      listRef.current.style.top = `${anchorHeight}px`;
    }
  };

  useEffect(() => {
    if (!isDropdownOpen) {
      return;
    }

    let timeoutId: number;
    const handleResize = (): void => {
      clearTimeout(timeoutId);

      timeoutId = window.setTimeout(calculateDropdownPosition, 500);
    };

    calculateDropdownPosition();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isDropdownOpen]);
};

export default useMenuPosition;
